
import React from "react";
import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const CloudLoginButton = () => {
  return (
    <Link to="/auth">
      <Button 
        variant="ghost" 
        className={cn(
          "flex items-center gap-2 rounded-full",
          "text-[rgba(202,206,210,0.85)]", // Muted color by default
          "hover:text-[rgba(248,249,250,0.9)]", // Brighter on hover
          "hover:bg-transparent" // Ensure no background on hover
        )}
        data-spark="true"
        data-spark-type="button"
      >
        <LogIn className="h-4 w-4" />
        <span>Login</span>
      </Button>
    </Link>
  );
};

export default CloudLoginButton;
